import {Async, Loaded, Loading } from 'Core/models/Async';

export class UnassignedCancerPolicyOption {
    
    public readonly key = 'UnassignedCancerPolicyOption';
  }

export type CancerPolicyOption = Async<string[]> | UnassignedCancerPolicyOption;

type MatchCancerPolicyOption<TReturn> = {
    Loading: () => TReturn;
    Loaded: (products: string[]) => TReturn;
    Error: () => TReturn;
    Unassigned: (products: []) => TReturn;
  };

export const isLoading = (products: CancerPolicyOption): products is Loading<string[]> =>
    products.key === 'Loading';

export const isLoaded = (products: CancerPolicyOption): products is Loaded<string[]> => products.key === 'Loaded';

export const matchCancerPolicyOptions = <TReturn>(options: MatchCancerPolicyOption<TReturn>) => (
    products: CancerPolicyOption
  ) => {
  
    switch (products.key) {
      case 'UnassignedCancerPolicyOption':
        return options.Unassigned([]);
      case 'Loaded':
        return options.Loaded(products.Data);
      case 'Loading':
        return options.Loading();
      case 'Conflict':
        return options.Error();
      case 'ServerError':
        return options.Error();
      case 'Unauthorized':
        return options.Error();
    }
  };
  